export default __webpack_public_path__ + "static/media/location.d48ffa74.svg";